import React, { useEffect, useRef } from 'react';

import './SwipeContainer.css';

type SwipePosition = 'left' | 'right';
interface Props {
  children: ((arg: SwipePosition) => React.ReactElement)[];
  shouldShowScanner: boolean;
  onManualModeEnter: () => void;
  onManualModeLeave: () => void;
}

export function SwipeContainer({
  children,
  shouldShowScanner,
  onManualModeEnter,
  onManualModeLeave,
}: Props): JSX.Element {
  const container = useRef<HTMLDivElement>(null);
  const [swipePosition, setSwipePosition] = React.useState<SwipePosition>('left');

  const handleScroll = (): void => {
    if (!container.current || !children[0] || !children[1]) return;
    const element = container.current;
    const containerWidth = element.getBoundingClientRect().width;
    const scrollOffset = container.current.scrollLeft;
    const gap = 15;

    if (containerWidth + gap === scrollOffset) {
      onManualModeEnter();
      setSwipePosition('right');
    } else if (scrollOffset === 0) {
      onManualModeLeave();
      setSwipePosition('left');
    }
  };

  const swipeLeft = (): void => {
    if (container.current) {
      container.current.scrollLeft = 0;
    }
  };

  const swipeRight = (): void => {
    if (container.current) {
      const element = container.current;
      const containerWidth = element.getBoundingClientRect().width;
      const gap = 15;
      container.current.scrollLeft = containerWidth + gap;
    }
  };
  useEffect(() => {
    if (shouldShowScanner) {
      swipeLeft();
    } else {
      swipeRight();
    }
  }, [shouldShowScanner]);

  return (
    <div className="swipe-container" ref={container} onScroll={handleScroll}>
      <div className="swipe-container__item">{children[0](swipePosition)}</div>
      <div className="swipe-container__item">{children[1](swipePosition)}</div>
    </div>
  );
}
